/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
import { Autocomplete, Box, IconButton, Modal, TextField } from "@mui/material";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import * as React from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { useAtualizaUsuario } from "services/api/AppWeb_TarefaLead/concluir-tarefa-recepcionista";
import { MdClose } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";
import TextFieldMUI from "@mui/material/TextField";
import { useEffect, useState } from "react";
import { useBuscarLogradouro } from "services/api";

import { useListarBairrosEmpreendimentos } from "services/api/Mobile_BairroEmpreendimento/bairros-empreendimentos";
import warn from "../../../../../../../constants/toast";
import { converterObjetoParaString } from "../../../../../../../hooks/convertObjectToString";
import { useListarAtendimentos } from "../../../../../../../services/api/AppWeb_Atendimento";
import { useIndicadores } from "../../../../../../../services/api/AppWeb_Atendimento/indicadores";
import { AuthState } from "../../../../../../../store/ducks/auth/types";

import * as Styles from "./styles";

export interface VisitaAgendadaStatesInterface {
  corretores: any;
  corretorDonoId: string | undefined;
}

interface DataLeadProps {
  nomeLead: string;
  telefoneLead: string;
  emailLead: string;
  visitaEmAberto: boolean;
  idTarefaLead: string;
  idLeadCorretor: string;
  nomeCorretor: string;
  retorno: boolean;
  empresaVenda: string | null;
  urlFotoUsuarioCorretor: string | null;
}

interface CorretorProps {
  label: string;
  value: string;
}
interface Props {
  isOpen: boolean;
  closeModal: () => void;
  visitaAgendadaStates: VisitaAgendadaStatesInterface;
  data: DataLeadProps | null;
  corretor: CorretorProps | null;
}

export function VisitaAgendadaModal(props: Props) {
  const { supervisorProduto } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { plantaoVendas: pdvSelected } = usePlantaoVendas();
  const [cep, setCep] = useState<any>("");
  const [bairro, setBairro] = useState<any>("");
  const [cidade, setCidade] = useState<any>("");
  const [bairroComercialValue, setBairroComercialValue] = useState<any>(null);
  const corretorEscolhido =
    props?.visitaAgendadaStates?.corretores?.data?.filter(
      (item: any) =>
        item?.idCorretor === props?.visitaAgendadaStates.corretorDonoId
    );
  const [corretorAtendente, setCorretorAtendente] = React.useState<{
    value: string;
    label: string;
  }>({
    label: corretorEscolhido?.nome,
    value: corretorEscolhido?.idCorretor,
  });
  const [filtros, setFiltros] = React.useState<any>(null);
  const { plantaoVendas } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const { refetch: refetchAtendimentos } = useListarAtendimentos({
    queryKey: "antendimentos",
    idLocalVendas: plantaoVendas?.id,
    params:
      filtros === null
        ? converterObjetoParaString({ PaginaAtual: 1, TotalItensRetorno: 25 })
        : converterObjetoParaString(filtros),
  });
  const { refetch: refetchIndicadores } = useIndicadores({
    queryKey: "listar_indicadores",
    idLocalVendas: supervisorProduto
      ? pdvSelected?.value || undefined
      : plantaoVendas?.id,
    params:
      filtros === null
        ? converterObjetoParaString({ PaginaAtual: 1 })
        : converterObjetoParaString(filtros),
  });

  const {
    mutate,
    isSuccess,
    isError,
    isLoading: isLoadingConclusao,
  } = useAtualizaUsuario(
    props?.data?.idTarefaLead ? props?.data?.idTarefaLead : "",
    {
      idCorretorAtendimento: corretorAtendente?.value,
      idLocalVenda: plantaoVendas?.id,
      cep,
      cidade,
      bairro,
      bairroComercial: bairroComercialValue?.value,
    }
  ) as any;

  React.useEffect(() => {
    if (isSuccess) {
      warn.wargingSuccess("Visita concluída com sucesso");
      refetchAtendimentos();
      refetchIndicadores();
      props.closeModal();

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }, [isSuccess]);

  React.useEffect(() => {
    if (isError) {
      warn.wargingError("Não foi possivel concluir a visita");
    }
  }, [isError]);

  React.useEffect(() => {
    setCorretorAtendente({
      label: corretorEscolhido?.[0]?.nome,
      value: corretorEscolhido?.[0]?.idCorretor,
    });
  }, []);

  React.useEffect(() => {
    console.log(props?.data);
    getFilter();
  }, [props?.data]);

  function transformObject(obj: any): any {
    const transformedObj: any = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fieldValue = obj[key];

        if (
          fieldValue &&
          typeof fieldValue === "object" &&
          "value" in fieldValue
        ) {
          transformedObj[key] = fieldValue.value;
        } else {
          transformedObj[key] = fieldValue;
        }
      }
    }

    return transformedObj;
  }

  const getFilter = async () => {
    const filtross: any = await localStorage.getItem("@sell.it/PDVFilters");
    const filtros2Json = JSON.parse(filtross);
    filtros2Json.PaginaAtual = 1;
    filtros2Json.TotalItensRetorno = 25;
    if (filtros2Json) {
      setFiltros(transformObject(filtros2Json));
    }
  };

  const { data: dataLogradouroResponse, refetch: refetchLogradouro } =
    useBuscarLogradouro({ cep });

  const handleCepChange = (event: any) => {
    const { value } = event.target;
    const numericValue = value.replace(/\D/g, "");
    const formattedValue = numericValue.slice(0, 8);
    const maskedValue = formattedValue.replace(/^(\d{5})(\d{3})$/, "$1-$2");
    setCep(maskedValue);
  };

  useEffect(() => {
    if (cep.length > 8) {
      refetchLogradouro();
    } else {
      setBairro("");
      setCidade("");
    }
  }, [cep]);

  const handleCepOnBlur = () => {
    setBairro(dataLogradouroResponse?.data?.bairro);
    setCidade(dataLogradouroResponse?.data?.cidade);
    if (cep.length === 0 || cep.length < 8) {
      setBairro("");
      setCidade("");
    }
  };

  const { data: dataBairros } = useListarBairrosEmpreendimentos({
    queryKey: "bairros_novo_atendimento",
  });

  return (
    <Modal open={props.isOpen} onClose={() => console.log("s")}>
      <Box sx={{ ...Styles.Modalstyle }}>
        <Styles.RowSpace>
          <Styles.Title>Visita agendada</Styles.Title>
          <IconButton onClick={props?.closeModal}>
            <MdClose />
          </IconButton>
        </Styles.RowSpace>

        <Styles.CardInfo>
          {props?.data?.urlFotoUsuarioCorretor ? (
            <Styles.Foto src={props?.data?.urlFotoUsuarioCorretor} />
          ) : (
            <FaUserCircle
              size={32}
              color="#424248"
              style={{ marginRight: 16 }}
            />
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: "84%",
            }}
          >
            <div>
              <Styles.CardInfoText style={{ marginBottom: 4 }}>
                {props?.corretor?.label} - {props?.data?.empresaVenda}
              </Styles.CardInfoText>
              <Styles.CardInfoText style={{ marginTop: 4 }}>
                {props?.data?.nomeLead}
              </Styles.CardInfoText>
            </div>
            <Styles.CardInfoStatus>
              {props?.data?.retorno ? "Retorno" : "Indicação"}
            </Styles.CardInfoStatus>
          </div>
        </Styles.CardInfo>
        <div style={{ display: "flex", gap: 16 }}>
          <div>
            <Styles.TitleAutocomplete style={{ marginTop: 8 }}>
              CEP
            </Styles.TitleAutocomplete>
            <TextFieldMUI
              value={cep}
              onChange={handleCepChange}
              onBlur={handleCepOnBlur}
              size="small"
              variant="outlined"
              label=""
              placeholder=""
              fullWidth
              style={{ height: 40 }}
              inputProps={{
                pattern: "^\\d{5}-\\d{3}$",
                maxLength: 9,
                style: {
                  height: 40,
                  padding: "0 16px",
                  borderRadius: 8,
                },
              }}
              InputLabelProps={{
                style: {
                  height: 40,
                },
              }}
            />
          </div>
          <div>
            <Styles.TitleAutocomplete style={{ marginTop: 8 }}>
              Bairro Residencial
            </Styles.TitleAutocomplete>
            <TextFieldMUI
              value={bairro}
              onChange={(e) => setBairro(e.target.value)}
              size="small"
              variant="outlined"
              label=""
              placeholder=""
              fullWidth
              style={{ height: 40 }}
              inputProps={{
                style: {
                  height: 40,
                  padding: "0 16px",
                  borderRadius: 8,
                },
              }}
              InputLabelProps={{
                style: {
                  height: 40,
                },
              }}
            />
          </div>
        </div>
        <Styles.TitleAutocomplete style={{ marginTop: 8 }}>
          Bairro Comercial
        </Styles.TitleAutocomplete>
        <Autocomplete
          id="combo-box-demo"
          sx={{ backgroundColor: "#fff", border: "none" }}
          options={dataBairros?.data?.map((item: any) => {
            return {
              label: item?.nome,
              value: item?.id,
            };
          })}
          value={bairroComercialValue}
          onChange={(event: any, value: any) => {
            setBairroComercialValue(value);
          }}
          autoHighlight
          size="small"
          fullWidth
          isOptionEqualToValue={(option, value) => option.value === value.value}
          getOptionLabel={(option) => option.label}
          renderOption={(props, option) => (
            <li {...props} key={option.value}>
              {option.label}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{
                "& .MuiAutocomplete-inputRoot": {
                  paddingLeft: "8px !important",
                  height: "40px",
                },
              }}
              placeholder=""
            />
          )}
        />
        <Styles.Line style={{ marginTop: 16 }} />
        <Styles.TitleAutocomplete style={{ marginTop: 8 }}>
          Quem irá atender o cliente?
        </Styles.TitleAutocomplete>
        <Autocomplete
          disablePortal
          id="combo-box-demo"
          onChange={(_e: any, newValue: any) => setCorretorAtendente(newValue)}
          value={corretorAtendente}
          options={props?.visitaAgendadaStates?.corretores?.data?.map(
            (item: { nome: string; idCorretor: string }) => {
              return {
                label: item?.nome,
                value: item?.idCorretor,
              };
            }
          )}
          size="small"
          renderInput={(params: any) => <TextField {...params} />}
        />
        <Styles.Footer>
          <Styles.BtnCancel onClick={props?.closeModal}>
            Cancelar
          </Styles.BtnCancel>
          <Styles.BtnConcluir
            disabled={corretorAtendente === null}
            onClick={() => mutate()}
          >
            {isLoadingConclusao ? (
              <BeatLoader color="#fff" size={10} />
            ) : (
              "Concluir visita"
            )}
          </Styles.BtnConcluir>
        </Styles.Footer>
      </Box>
    </Modal>
  );
}
